import mqtt from 'mqtt'
import store from "../store/index"

var client
// const MQTTURL = "mqtt://local.vrmaker.vip:8083/mqtt"
// const MQTTURL = "wss://local.vrmaker.com.cn:18888/mqtt"
const MQTTURL = "ws://10.10.1.198:8083/mqtt"

export async function subscribebySubLoopUrl(subLoopUrl) {
    // if(!client){
    //     await connect()
    // }
    if (Array.isArray(subLoopUrl)) {
        subLoopUrl.forEach(item => {
            client.subscribe(`VrMaker/${store.state.db}/+/PUBLISH/${item}/#`)
            // console.log('订阅：' + `VrMaker/${store.state.db}/+/PUBLISH/${item}/#`)
        })
    } else {
        client.subscribe(`VrMaker/${store.state.db}/+/PUBLISH/${subLoopUrl}/#`)
        // console.log('订阅：' + `VrMaker/${store.state.db}/+/PUBLISH/${subLoopUrl}/#`)
    }
}

export async function unsubscribebySubLoopUrl(subLoopUrl) {
    if (Array.isArray(subLoopUrl)) {
        subLoopUrl.forEach(item => {
            client.unsubscribe(`VrMaker/${store.state.db}/+/PUBLISH/${item}/#`)
            // console.log('取消订阅：' + `VrMaker/${store.state.db}/+/PUBLISH/${item}/#`)
        })
    } else {
        client.unsubscribe(`VrMaker/${store.state.db}/+/PUBLISH/${subLoopUrl}/#`)
        // console.log('取消订阅：' + `VrMaker/${store.state.db}/+/PUBLISH/${subLoopUrl}/#`)
    }
}
// 订阅回路
function createNodeTopics(nodes) {
    return nodes.map(item => {
        return `VrMaker/${store.state.db}/+/PUBLISH/+/+/+/${item}`
    })
}
// 订阅少一个+适配的回路
function createNodeTopics1(nodes) {
    return nodes.map(item => {
        return `VrMaker/${store.state.db}/+/PUBLISH/+/+/${item}`
    })
}

export function subscribeByNodes(nodes) {
    client && client.subscribe(createNodeTopics(nodes));
    client && client.subscribe(createNodeTopics1(nodes));
}

export function unsubscribeByNodes(nodes) {
    client && client.unsubscribe(createNodeTopics(nodes));
    client && client.unsubscribe(createNodeTopics1(nodes));
}

export async function connect() {
    client = mqtt.connect(MQTTURL, {
        username: "vrmaker",
        password: "vrmaker",
    })

    await new Promise((resolve, reject) => {
        client.on("connect", () => {
            console.log('mqtt链接成功')
            resolve();
        });
    })

    client.on("message", (topic, message) => {
        // console.log(topic,Number(message));
        let keys = topic.split('/')
        let len = keys.length
        let devicesName = keys.slice(4, len - 1).join('/')
        let topicName = keys.slice(4).join('/')

        // console.log(topicName, Number(message));

        store.commit("addMQTTData", {
            key: topicName,
            val: message,
        })
    })

    client.on("error", (err) => {
        console.log("mqtt error !!!", err)
        client.end()
    })

    client.on("close", () => {
        console.log("mqtt closed!")
    })
}

export async function destroyConnection() {
    if (client) {
        try {
            client.end()
            client = null
            console.log('Successfully disconnected!')
        } catch (error) {
            console.log('Disconnect failed', error.toString())
        }
    }
}